import { computed, makeObservable } from 'mobx'

import { ExtendedColumnConfigProps } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/ExtendedColumns.types'
import { arrivalsModeColumns } from '@new/domains/fastBookingsTapeChart/components/ExtendedColumns/ExtendedColumns.utils'

import { BaseStore } from '../__types'

export class ArrivalsModeStore {
  constructor(private getFilterStore: () => BaseStore['filterStore']) {
    makeObservable(this, {
      isArrivalsModeActive: computed,
      arrivalsModeColumns: computed,
    })
  }

  get filterStore() {
    return this.getFilterStore()
  }

  get isArrivalsModeActive(): boolean {
    return this.filterStore.arrivalsMode
  }

  get arrivalsModeColumns(): ExtendedColumnConfigProps[] {
    return this.isArrivalsModeActive ? arrivalsModeColumns : []
  }
}
